import axios from 'axios';
import * as Constants from "../common/constants";
import AuthService from './authService';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { CategoryModel } from "../models/category/categoryModel";
//import { CategoryFilterSettingsModel } from "../models/category/categoryFilterSettingsModel";

class CategoryService {
  authService = new AuthService();
  constructor() {
    axios.defaults.baseURL = `${Constants.apiUrl}/`;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${this.authService.getToken()}`,
      Pragma: 'no-cache'
    }
  }

  getAllCategories() {
    return axios({
      url: `categories/getAll`,
      method: 'get', headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getAllActive() {
    return axios({
      url: `categories/getAllActive`,
      method: 'get', headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getAllActiveCategories() {
    return axios({
      url: `categories/getAllActive`,
      method: 'get', headers: {
        "Content-Type": "application/json; charset=utf-8"
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getCategory(id: number) {
    return axios({
      url: `categories/getById/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  addCategory(category: CategoryModel) {
    return axios({
      url: `categories/create`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(category)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  editCategory(category: CategoryModel) {
    return axios({
      url: `categories/update`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(category)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  deleteCategory(id: number) {
    return axios({
      url: `categories/delete/${id}`,
      method: 'delete'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  updateCategoriesOrder(categories: Array<CategoryModel>) {
    return axios({
      url: `categories/updateOrder`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(categories)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default CategoryService;
